export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: false,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '审批编号',
      prop: 'flowId',
      display: false,
      search: false,
    },
    {
      label: '资料类型',
      prop: 'busType',
      display: false,
      search: false,
      dicData:[
        {
          label: '钥匙',
          value: 0
        },
        {
          label: '证书',
          value: 1
        },
      ]
    },
    {
      label: '主计量',
      prop: 'unit',
      display: false,
      hide: true,
    },
    {
      label: '出库时间',
      prop: 'deliveryTime',
      span: 24,
      display: false,
    },
    {
      label: '出库数量',
      prop: 'amount',
      span: 24,
      display: false,
    },
    {
      label: '申请原因',
      prop: 'cause',
      span: 24,
      display: false,
      dicData: [
        {
          label: '车辆销售',
          value: 1,
        },
        {
          label: '结清',
          value: 2,
        },
        {
          label: '其他',
          value: 3,
        },
      ],
    },
    {
      label: '备注',
      prop: 'remark',
      span: 24,
      display: false,
    },
    {
      label: '操作人',
      prop: 'updateUserName',
      span: 24,
      display: false,
    },
    // {
    //   label: '操作时间',
    //   prop: 'updateTime',
    //   span: 24,
    //   display: false,
    // },
  ],

};
